<template>
  <transition name="terms-modal-fade">
    <div v-if="modelValue" class="terms-modal" @click.self="$emit('update:modelValue', false)">
      <div class="terms-modal__dialog" role="dialog" aria-modal="true" aria-labelledby="terms-modal-title">
        <div class="terms-modal__header">
          <div>
            <small class="terms-modal__eyebrow">Legal</small>
            <h3 id="terms-modal-title">Terminos y condiciones</h3>
          </div>
          <button type="button" class="terms-modal__close" aria-label="Cerrar" @click="$emit('update:modelValue', false)">
            <span aria-hidden="true">x</span>
          </button>
        </div>

        <div class="terms-modal__body">
          <p>
            Estos terminos aplican a todas las versiones del sitio y aplicaciones de FOMOPLANES. Al visitar el sitio,
            registrarte o comprar entradas, aceptas estas condiciones y sus futuras actualizaciones.
          </p>
          <p>
            Los eventos publicados en FOMOPLANES son responsabilidad de sus organizadores. La plataforma se encarga de la
            comercializacion, promocion y exposicion digital de los accesos.
          </p>
          <p>
            La informacion personal entregada para registro, validacion y compra se usa solo para fines del servicio. No se
            almacenan datos de tarjetas en la plataforma.
          </p>
          <p>
            El usuario es responsable de revisar fecha, funcion, localidad y cantidad antes de pagar. No hay cambios,
            devoluciones ni reembolsos por errores del comprador ni por fees ya aceptados.
          </p>
          <p>
            En caso de cancelacion, reprogramacion o devoluciones, la responsabilidad principal recae en el organizador.
            FOMOPLANES puede colaborar con la gestion cuando exista autorizacion previa o acuerdo formal.
          </p>
          <p>
            Si agregas Fomo Safe durante el checkout, ese valor se cobra como addon independiente y su cobertura queda sujeta
            a elegibilidad, revision documental y validacion interna.
          </p>
          <p>
            Toda controversia se trata bajo las leyes de la Republica del Ecuador ante la jurisdiccion ordinaria competente.
          </p>
        </div>

        <div class="terms-modal__footer">
          <router-link class="terms-modal__link" :to="{ name: 'terms' }" target="_blank" rel="noopener">Ver version completa</router-link>
          <button type="button" class="terms-modal__action" @click="$emit('update:modelValue', false)">Entendido</button>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: 'TermsModal',
  props: {
    modelValue: {
      type: Boolean,
      default: false,
    },
  },
}
</script>

<style scoped>
.terms-modal {
  position: fixed;
  inset: 0;
  z-index: 2000;
  display: grid;
  place-items: center;
  padding: 20px;
  background: rgba(5, 7, 12, 0.74);
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
}

.terms-modal__dialog {
  width: min(760px, 100%);
  max-height: min(88vh, 920px);
  overflow: hidden;
  border-radius: 24px;
  border: 1px solid rgba(255, 255, 255, 0.1);
  background: linear-gradient(180deg, rgba(16, 18, 25, 0.98), rgba(9, 11, 16, 0.98));
  box-shadow: 0 28px 70px rgba(0, 0, 0, 0.36);
}

.terms-modal__header,
.terms-modal__footer {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  padding: 18px 22px;
}

.terms-modal__header {
  border-bottom: 1px solid rgba(255, 255, 255, 0.08);
}

.terms-modal__footer {
  border-top: 1px solid rgba(255, 255, 255, 0.08);
}

.terms-modal__eyebrow {
  display: block;
  margin-bottom: 4px;
  color: rgba(210, 216, 228, 0.64);
  font-size: 0.72rem;
  letter-spacing: 0.12em;
  text-transform: uppercase;
}

.terms-modal__header h3 {
  margin: 0;
  color: #f4f6fb;
  font-size: 1.2rem;
}

.terms-modal__close,
.terms-modal__action {
  border: 1px solid rgba(255, 255, 255, 0.12);
  background: rgba(255, 255, 255, 0.06);
  color: #f4f6fb;
}

.terms-modal__close {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  border-radius: 999px;
}

.terms-modal__action {
  min-height: 42px;
  padding: 0 18px;
  border-radius: 999px;
  font-weight: 600;
}

.terms-modal__body {
  overflow: auto;
  max-height: calc(88vh - 150px);
  padding: 22px;
  color: rgba(222, 228, 240, 0.88);
  line-height: 1.65;
}

.terms-modal__body p {
  margin: 0 0 14px;
}

.terms-modal__link {
  color: rgba(222, 228, 240, 0.76);
  text-decoration: underline;
  text-underline-offset: 3px;
}

.terms-modal-fade-enter-active,
.terms-modal-fade-leave-active {
  transition: opacity 0.18s ease;
}

.terms-modal-fade-enter-from,
.terms-modal-fade-leave-to {
  opacity: 0;
}

@media (max-width: 640px) {
  .terms-modal {
    padding: 12px;
  }

  .terms-modal__header,
  .terms-modal__footer,
  .terms-modal__body {
    padding-left: 16px;
    padding-right: 16px;
  }

  .terms-modal__footer {
    align-items: stretch;
    flex-direction: column;
  }

  .terms-modal__action,
  .terms-modal__link {
    width: 100%;
    text-align: center;
  }
}
</style>
